export default "__VITE_ASSET__DLyCmdZ6__"